import { AxiosResponse } from "axios";
import { AxiosInstance } from "./axiosInstance";
import { ReleaseVersionResponse } from "./interfaces/releaseInterface.interface";

const API_PATH = "/releaseVersions";

export const getReleaseVersion =
  async ({}: {}): Promise<ReleaseVersionResponse> => {
    try {
      const res: AxiosResponse<ReleaseVersionResponse> =
        await AxiosInstance.get(`${API_PATH}`);
      return res.data;
    } catch (e) {
      console.error(e);
      throw new Error();
    }
  };

export const getReleaseVersionId = async ({
  versionId,
}: {
  versionId: string;
}): Promise<ReleaseVersionResponse> => {
  try {
    const res: AxiosResponse<ReleaseVersionResponse> = await AxiosInstance.get(
      `${API_PATH}/${versionId}`
    );
    return res.data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const getReleaseLatestVersion =
  async (): Promise<ReleaseVersionResponse> => {
    try {
      const res: AxiosResponse<ReleaseVersionResponse> =
        await AxiosInstance.get(`${API_PATH}/latest`);
      return res.data;
    } catch (e) {
      console.error(e);
      throw new Error();
    }
  };
